export default __webpack_public_path__ + "static/media/General configuration.88815f11.png";